module.exports = __webpack_public_path__ + "static/media/universalSupport.cbe408a6.png";